<div class="details-section-title">
  <div class="title">
    <app-text-with-placeholder [showPlaceholder]="loading">Recent Notes</app-text-with-placeholder>
    @if (!loading) {
      <button rktButton btnType="link" class="notes-refresh-btn" (click)="fetchNotes()">
        <rkt-icon name="refresh"></rkt-icon>
      </button>
    }
  </div>

  <div class="controls">
    @if (!addNote) {
      <button rktButton btnType="link" class="control-btn" [disabled]="!!(loading | accessControl | async)" (click)="addNote = !addNote">
        <rkt-icon name="plus"></rkt-icon>
        Add Note
      </button>
    }
  </div>
</div>

<div class="details-content">
  @if (addNote) {
    <div>
      <app-notes-feed-add-note
        (addBtnClick)="onNoteAdd($event)"
        (discardClick)="onNoteAddDiscard($event)"
        [loading]="newNoteLoading"
        [error]="noteAddError"
      ></app-notes-feed-add-note>
      <div class="separator-row"></div>
    </div>
  }

  <div class="notes-feed">
    @for (noteItem of notes$ | async; track noteItem) {
      <app-notes-feed-item [note]="noteItem"></app-notes-feed-item>
    }

    @if (!(notes$ | async)?.length) {
      <div class="notes-empty-message">There are no notes.</div>
    }
  </div>
</div>
